import type { AnyRoute } from "@tanstack/react-router";

import { createScheduleMaintenanceRoutes } from "./createScheduleMaintenanceRoutes";
import type { MaintenanceRouteDeps } from "./maintenanceRouteContext";

export type {
  MaintenanceRouteDeps,
  MaintenanceRouteFactory,
} from "./maintenanceRouteContext";

export function createMaintenanceRoutes(
  deps: MaintenanceRouteDeps,
): AnyRoute[] {
  return [...createScheduleMaintenanceRoutes(deps)];
}
